
export const getCustomProjectCodeIfIsOv = (project) => {
    return (
        project.code.includes('-') && project.code.includes('100')
          ? (
              (
                project.code.split('-').pop().trim().startsWith('OV')
                  ? project.code.split('-').pop().trim()
                  : 'OV' + project.code.split('-').pop().trim()
              ) + ' - ' + project.name
            )
          : `${project.code} - ${project.name}`
      )
}